/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { Sidebar, Layout as RALayout } from "react-admin";
import Menu from "./Menu";
import AppBar from "./AppBar";
import theme from "./theme";
import { makeStyles } from "@material-ui/core/styles";
import { NpsPopup } from "../components/NpsPopup/NpsPopup";
import Container from "@material-ui/core/Container";
import { TrialReminder } from "./TrialReminder";
import Questionnaire from "../components/Questionnaire/Questionnaire";
import { useLocation } from "react-router-dom";
import styled from "@emotion/styled";

const useStyles = makeStyles({
  content: {
    display: 'flex',
    margin: 0,
    padding: theme.spacing(5),
    paddingBottom: theme.spacing(15),
  },
});

const Layout = (props) => {
  const classes = useStyles();

  const location = useLocation();
  const openQuestionnaire = location.hash === "#questionnaire" ? true : false;
  const CustomSidebar = styled(Sidebar)`
    .MuiDrawer-paper {
      @media only screen and (max-width: 956px) {
      position: fixed;
      z-index: 5555;
      height: 100%;
      }
    }
  `;
  return (
    <RALayout
    style={{ backgroundColor: "#FCFCFC" }}
    {...props}
      menu={Menu}
      appBar={AppBar}
      theme={theme}
      sidebar={(props) => {
        return <CustomSidebar {...props} />;
      }}
      classes={classes}
    >
      <TrialReminder />
      <Container style={{ margin: 0, padding: 0 }}>{props.children}</Container>
      <NpsPopup />
      <Questionnaire isOpen={openQuestionnaire} />
    </RALayout>
  );
};

export default Layout;
